module.exports = __webpack_public_path__ + "assets/5c27d5bcbeb2ba4b860ab2cf96d75372.png";